export default __webpack_public_path__ + "d517194e6891227e66d6fde65d2dab48.svg";